export default function visibilitySync(store) {
    // no need to remove this listener since we use it in a vuex store plugin and the store is loaded on every page
    // eslint-disable-next-line tipsi/remove-event-listener
    document.addEventListener('visibilitychange', () =>
        store.commit('ui/SET_PAGE_IS_VISIBLE', document.visibilityState === 'visible'),
    );
}
